import React, { useState } from "react";
import i18n from "../lib/i18n";

import UIBox from "./UIBox";

const DepositionSettings = (props) => {
  const { isReadOnly, plan } = props;
  const [altYearlyDeposition, setAltYearlyDeposition] = useState(
    plan.attributes.alt_yearly_deposition
  );
  const [yearlyDeposition, setYearlyDeposition] = useState(
    plan.attributes.yearly_deposition
  );
  const [startBalance, setStartBalance] = useState(
    plan.attributes.start_balance
  );

  const onSubmit = (event, attributes) => {
    event.preventDefault();
    props.onChange(attributes);
  };

  let recommendedDepositionTitle = i18n.t(
    "js.components.deposition_settings.recommended_yearly_deposition"
  );
  if (!isReadOnly) {
    recommendedDepositionTitle += "<sup>*</sup>";
  }
  return (
    <div data-cy="deposition-settings">
      <div className="row">
        <UIBox cols={6} heading={recommendedDepositionTitle} row={false}>
          <form
            role="form"
            onSubmit={(event) => {
              onSubmit(event, {
                alt_yearly_deposition: altYearlyDeposition,
              });
            }}
          >
            <div className="form-group">
              {isReadOnly && (
                <p style={{ fontSize: "28px" }}>
                  {plan.attributes.alt_yearly_deposition}{" "}
                  {i18n.t("js.helpers.currency")}
                </p>
              )}
              {!isReadOnly && (
                <div className="input-group">
                  <span className="input-group-addon">
                    {i18n.t("js.helpers.currency")}
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={altYearlyDeposition}
                    onChange={(event) =>
                      setAltYearlyDeposition(event.target.value)
                    }
                    placeholder={i18n.t(
                      "js.components.deposition_settings.recommended_deposition"
                    )}
                  />
                </div>
              )}
              <br />
              {!isReadOnly && (
                <input
                  type="submit"
                  className="btn btn-primary"
                  value={i18n.t("js.components.deposition_settings.update")}
                />
              )}

              {!isReadOnly && (
                <p style={{ marginTop: "10px" }}>
                  <sup>*</sup>{" "}
                  {i18n.t("js.components.deposition_settings.info")}
                </p>
              )}
            </div>
          </form>
        </UIBox>
        <UIBox
          cols={6}
          heading={i18n.t(
            "js.components.deposition_settings.current_yearly_deposition"
          )}
        >
          <form
            role="form"
            onSubmit={(event) => {
              onSubmit(event, {
                yearly_deposition: yearlyDeposition,
              });
            }}
          >
            <div className="form-group">
              {isReadOnly && (
                <p style={{ fontSize: "28px" }}>
                  {plan.attributes.yearly_deposition}{" "}
                  {i18n.t("js.helpers.currency")}
                </p>
              )}
              {!isReadOnly && (
                <div className="input-group">
                  <span className="input-group-addon">
                    {i18n.t("js.helpers.currency")}
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={yearlyDeposition}
                    onChange={(event) =>
                      setYearlyDeposition(event.target.value)
                    }
                    placeholder={i18n.t(
                      "js.components.deposition_settings.current_deposition"
                    )}
                  />
                </div>
              )}
              <br />
              {!isReadOnly && (
                <input
                  type="submit"
                  className="btn btn-primary"
                  value={i18n.t("js.components.deposition_settings.update")}
                />
              )}
            </div>
          </form>
        </UIBox>
      </div>

      <form
        role="form"
        onSubmit={(event) => {
          onSubmit(event, { start_balance: startBalance });
        }}
      >
        <UIBox
          cols={6}
          heading={i18n.t("js.components.deposition_settings.current_balance", {
            year: plan.attributes.start_year,
          })}
          row={true}
        >
          <div className="form-group">
            {isReadOnly && (
              <p style={{ fontSize: "28px" }}>
                {plan.attributes.start_balance} {i18n.t("js.helpers.currency")}
              </p>
            )}

            {!isReadOnly && (
              <>
                <div className="input-group">
                  <span className="input-group-addon">
                    {i18n.t("js.helpers.currency")}
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={startBalance}
                    onChange={(event) => setStartBalance(event.target.value)}
                    placeholder={i18n.t(
                      "js.components.deposition_settings.balance"
                    )}
                  />
                </div>
                <br />
                <input
                  type="submit"
                  className="btn btn-primary"
                  value={i18n.t("js.components.deposition_settings.update")}
                />
              </>
            )}
          </div>
        </UIBox>
      </form>
    </div>
  );
};

export default DepositionSettings;
